export default __webpack_public_path__ + "static/media/woodcut-lion.78fe398d.png";